// directives/typewriter.js
export default {
  getSSRProps() {
    // noop needed to be SSR compatible
    return {};
  },
  mounted(el, binding) {
    const { speed = 100, delay = 0 } = binding.value || {};

    // 1. Get the raw text and split it into characters
    const text = el.innerText.trim();
    el.innerHTML = ""; // Clear once to rebuild with spans
    // show element in terms of opacity cloaking
    el.style.opacity = 1;

    // 2. Wrap every character in a span (hidden by default)
    const charSpans = text.split("").map((char) => {
      const span = document.createElement("span");
      span.innerText = char;
      span.style.visibility = "hidden";
      el.appendChild(span);
      return span;
    });

    const startTyping = () => {
      let i = 0;
      const type = () => {
        if (i < charSpans.length) {
          charSpans[i].style.visibility = "visible";
          i++;
          setTimeout(type, speed);
        }
      };
      setTimeout(type, delay);
    };

    // 3. Intersection Observer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startTyping();
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1 },
    );

    observer.observe(el);
  },
};
